import { Box, IconButton, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import { FC, useEffect, useState } from "react";

import Loader from "../../../components/Loader";
import TooltipPopover from "../../../components/TooltipPopover";
import { OrderStatus } from "../types";

const EditableText: FC<orderStatusDeliveryProps> = ({
  children,
  sourceOriginalValue,
  canEdit,
  onUpdate,
  message,
  isDisabled,
  classesNames = "",
  colorValue = "",
}) => {
  const [value, setValue] = useState<any>(sourceOriginalValue);
  const [isInEditMode, setIsInEditMode] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleCancelEditMode = () => {
    setIsInEditMode(false);
    setValue(sourceOriginalValue);
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await onUpdate();
      setValue(response.updatedValue);
      setLoading(false);
      setIsInEditMode(false);
    } catch (ex: any) {
      console.log(ex);
      setValue(ex.originalValue);
      setLoading(false);
      setIsInEditMode(false);
    }
  };

  useEffect(() => {
    setValue(sourceOriginalValue);
  }, [sourceOriginalValue]);

  return (
    <>
      {isInEditMode ? (
        <Box display="flex" alignItems="center">
          {children}
          <Box display="flex" alignItems="center">
            <Loader loading={loading} size={18}>
              <TooltipPopover message={message}>
                <IconButton onClick={handleSubmit} size="small" disabled={isDisabled}>
                  <CheckIcon fontSize="small" color="primary" />
                </IconButton>
              </TooltipPopover>
            </Loader>

            <TooltipPopover message="Cancel">
              <IconButton disabled={loading} size="small" onClick={handleCancelEditMode}>
                <CloseIcon fontSize="small" color="error" />
              </IconButton>
            </TooltipPopover>
          </Box>
        </Box>
      ) : (
        <Box display="flex" alignItems="center">
          <Typography variant="body2" className={classesNames} style={{ color: colorValue }}>
            {value} {value === OrderStatus.failed || value === OrderStatus.pending ? "payment" : ""}
          </Typography>

          {canEdit && (
            <TooltipPopover message="Edit">
              <IconButton
                onClick={() => {
                  setIsInEditMode(true);
                }}
                style={{ marginInline: 2 }}
              >
                <EditIcon fontSize="small" style={{ fontSize: "1rem", color: "#21C5FD" }} />
              </IconButton>
            </TooltipPopover>
          )}
        </Box>
      )}
    </>
  );
};

interface orderStatusDeliveryProps {
  sourceOriginalValue: any;
  canEdit: boolean;
  onUpdate: () => Promise<{ updatedValue: any }>;
  message: string;
  isDisabled: boolean;
  classesNames?: string;
  colorValue?: string;
}

export default EditableText;
